<template>
  <byted-popover
    v-model="isGuide"
    :popper-class="popperClass"
    trigger="manual"
    :transfer="transfer"
    :placement="placement"
    :offset="offset"
    :width="width"
  >
    <template slot="header">
      <slot name="title" />
      <byted-icon
        class="guide-delete"
        name="close"
        color="#98BEEF"
        width="16px"
        height="16px"
        @click="handleCloseGuide"
      />
    </template>
    <slot name="content" slot="body" />
    <template slot="footer">
      <byted-button
        v-if="secondaryBtn.text"
        class="btn-custom-text__dark"
        type="text"
        size="xs"
        @click.stop="handleBtnClick(secondaryBtn)"
      >{{ secondaryBtn.text }}</byted-button>
      <byted-button
        v-if="primaryBtn.text"
        class="btn-custom-primary__dark"
        type="primary"
        size="xs"
        @click.stop="handleBtnClick(primaryBtn)"
      >{{ primaryBtn.text }}</byted-button>
    </template>
    <slot
      name="reference"
      slot="reference"
    />
  </byted-popover>
</template>

<script>
export default {
  name: 'BeginnerGuidePopover',
  props: {
    guideKey: {
      type: String,
      required: true
    },
    transfer: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'right-start'
    },
    offset: {
      type: String,
      default: '0px'
    },
    width: {
      type: String,
      default: 'auto'
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    primaryBtn: {
      type: Object,
      default () {
        return {
          text: '', // 按钮文案
          isClose: false, // 点击该按钮，是否要关闭 popover ，与 jumpPage 互斥，优先级高
          jumpPage: '' // 点击该按钮，是否要跳转页面，与 isClose 互斥，优先级低
        }
      }
    },
    secondaryBtn: {
      type: Object,
      default () {
        return {
          text: '',
          isClose: false,
          jumpPage: ''
        }
      }
    }
  },

  data () {
    return {
      isGuide: false
    }
  },

  created () {
    this.isGuide = window.localStorage.getItem(this.guideKey) !== 'off'
  },

  computed: {
    popperClass () {
      let classes = 'beginner-guide-popover'
      if (!this.$slots.content) return classes + ' is-empty-content'
      return classes
    }
  },

  methods: {
    handleCloseGuide () {
      this.isGuide = false
      window.localStorage.setItem(this.guideKey, 'off')
    },
    handleBtnClick (btn) {
      this.$emit(btn === this.primaryBtn ? 'primary-click' : 'secondary-click')

      if (btn.isClose) return this.handleCloseGuide()
      if (btn.jumpPage) {
        this.handleCloseGuide()
        window.location.href = this.globalUpdateQuery(btn.jumpPage)
        return
      }
    }
  }

}
</script>

<style lang="scss">
.beginner-guide-popover {
  &.is-empty-content {
    .bui-popover-header {
      margin-bottom: 0 !important;
      line-height: 16px !important;
    }
  }

  .bui-popover-arrow {
    background: #2f88ff;
    border-color: #2f88ff;
  }

  .bui-popover-panel {
    position: relative;
    background: linear-gradient(120.84deg, #338aff .69%, #2f75d3 100.61%);
    box-shadow: 0 4px 14px rgba(0, 0, 0, .1);

    .bui-popover-header {
      color: #fff;

      .guide-delete {
        position: absolute;
        top: 16px;
        right: 16px;
      }
    }

    .bui-popover-body {
      color: #fff;
    }

    .bui-popover-footer {
      text-align: right;
    }
  }

  .bui-btn.btn-custom-primary__dark {
    color: #338aff;
    background-color: #fff;
    border-color: #fff;

    &:hover {
      color: #58a0ff;
      background-color: #fff;
    }
  }

  .btn-custom-text__dark {
    color: #fff;

    &:hover {
      color: #fff;
    }
  }
}
</style>
